import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=96ca0804&scoped=true&"
import script from "./Scopes.vue?vue&type=script&lang=js&"
export * from "./Scopes.vue?vue&type=script&lang=js&"
import style0 from "./Scopes.vue?vue&type=style&index=0&id=96ca0804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca0804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VChip,VChipGroup,VDivider,VImg,VProgressLinear})
